import "./app_bar.css";
import React from "react";
import { isAndroid } from "react-device-detect";

export const HelloAutoAppBar = (props) => {
  return (
    <div
      className="app-bar-helloauto"
      style={{
        backgroundColor: props.backgroundColor,
        color: props.textColor,
      }}
    >
      <p className="parrafo-appbar silka-bold">
        <i
          onClick={props.onBackClick}
          className={
            isAndroid
              ? "fa fa-arrow-left app-bar-icono-color"
              : "fa fa-chevron-left app-bar-icono-color"
          }
        ></i>
        {props.title}
      </p>
    </div>
  );
};
